<script setup lang='ts'>
import { computed } from 'vue';
import i18n from '@/lang/i18n';

type statusType = {
  [key: string]: {
    class: string;
    label: string;
  };
};

const props = defineProps<{
  status: string;
  hasMessage: boolean;
}>();

const label = computed(() => {
  return statuses[props.status]?.label ?? '';
});
const className = computed(() => {
  return statuses[props.status]?.class ?? '';
});

const subMessage = computed(() => {
  return props.hasMessage ?
    i18n.global.t('pages.downloadData.messages.clickForDetails') :
    '';
});

const statuses: statusType = {
  failed: { class: 'bg-danger text-white', label: i18n.global.t('pages.downloadData.messages.failed') },
  running: { class: 'bg-info', label: i18n.global.t('pages.downloadData.creating') },
  waiting: { class: 'bg-info', label: i18n.global.t('pages.downloadData.creating') },
  success: { class: 'bg-success', label: i18n.global.t('pages.downloadData.createComplate') },
};
</script>

<template>
  <p class="m-0 text-center" :class="className">{{ label }}</p>
  <p class="m-0 pl-1 text-end x-small" v-if="props.hasMessage">
    {{ subMessage }}
  </p>
</template>

<style scoped>
.x-small {
  font-size: x-small;
}
</style>
